export default {
      id: "maghrib-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#maghrib",
      toString: function () {
        return this.url;
      }
    }